import { render, staticRenderFns } from "./copiaCespitiNonAssegnatiAdmin.vue?vue&type=template&id=1b57c544&"
import script from "./copiaCespitiNonAssegnatiAdmin.vue?vue&type=script&lang=js&"
export * from "./copiaCespitiNonAssegnatiAdmin.vue?vue&type=script&lang=js&"
import style0 from "./copiaCespitiNonAssegnatiAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VForm,VImg,VRow,VSwitch,VTextField,VTextarea})
